import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addSubSection,
  deleteSubSection,
  getSections,
  updateSection,
} from "./homePageSlice";
import {
  Container,
  Card,
  Row,
  Col,
  Toast,
  Form,
  Modal,
  Button,
} from "react-bootstrap";
import CommonFormLabel from "../../../components/formLabel";
import CommonButton from "../../../components/commonButton";
import Input from "../../../components/input";
import Textarea from "../../../components/commonTextArea";
import Editor from "../../../components/commonEditor";
import { useLoader } from "../../../context/LoaderContext";
import FileInput from "../../../components/fileInput";
import { Formik } from "formik";
import CommonTable from "../../../components/commonTable/index";

const HomePage = ({ slug, organizationId }) => {
  const dispatch = useDispatch();

  // const location = useLocation();
  //   const pathSegments = location.pathname.split("/").filter(Boolean);
  //   const selected_organization_id = pathSegments.length > 1 && pathSegments[0] === "organization"
  //     ? pathSegments[1]
  //     : null;
  const { setLoading } = useLoader();
  const { sections } = useSelector((state) => state.homePage);
  const [editingSectionId, setEditingSectionId] = useState(null);
  const [editingSubSectionId, setEditingSubSectionId] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const [SectionData, setSectionData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedSubSection, setSelectedSubSection] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addSectionType, setAddSectionType] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSubSections, setDeleteSubSections] = useState(null);

  useEffect(() => {
    setLoading(true);
    const fetchSections = async () => {
      try {
        const payload = { slug, organization_id: organizationId };
        const result = await dispatch(getSections({ payload }));
        setSectionData(result.payload.data);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching sections:", error);
        setSnackbarMessage("Failed to load sections.");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, [dispatch, setLoading, organizationId, slug]);

  const handleSubmit = async (
    sectionId,
    updatedSectionContents,
    subSectionContents = null
  ) => {
    try {
      const formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("organization_id", organizationId);

      updatedSectionContents.forEach((content, index) => {
        formData.append(`section_contents[${index}][id]`, content.id);
        if (content.content instanceof File) {
          formData.append(
            `section_contents[${index}][content]`,
            content.content
          );
        } else {
          formData.append(
            `section_contents[${index}][old_content]`,
            content.content
          );
        }

        formData.append(
          `section_contents[${index}][content_type]`,
          content.content_type
        );

        // content.section_content_items?.forEach((item, itemIndex) => {
        //   formData.append(`section_contents[${index}][section_content_items][${itemIndex}][id]`, item.id);
        //   if (item.image instanceof File) {
        //     formData.append(`section_contents[${index}][section_content_items][${itemIndex}][image]`, item.image);
        //   } else {
        //     formData.append(`section_contents[${index}][section_content_items][${itemIndex}][old_image]`, item.image);
        //   }
        //   formData.append(`section_contents[${index}][section_content_items][${itemIndex}][title]`, item.title || "");
        //   formData.append(`section_contents[${index}][section_content_items][${itemIndex}][description]`, item.description || "");
        // });
      });

      // If updating sub-sections, add their contents
      if (subSectionContents) {
        subSectionContents.forEach((subSectionContent, subIndex) => {
          formData.append(
            `sub_sections[${subIndex}][id]`,
            subSectionContent.id
          );
          subSectionContent.section_contents?.forEach((content, index) => {
            formData.append(
              `sub_sections[${subIndex}][section_contents][${index}][id]`,
              content.id
            );
            if (content.content instanceof File) {
              formData.append(
                `sub_sections[${subIndex}][section_contents][${index}][content]`,
                content.content
              );
            } else {
              formData.append(
                `sub_sections[${subIndex}][section_contents][${index}][old_content]`,
                content.content
              );
            }
            formData.append(
              `sub_sections[${subIndex}][section_contents][${index}][content_type]`,
              content.content_type
            );
            // content.section_content_items?.forEach((item, itemIndex) => {
            //   formData.append(`sub_sections[${subIndex}][section_contents][${index}][section_content_items][${itemIndex}][id]`, item.id);
            //   if (item.image instanceof File) {
            //     formData.append(`sub_sections[${subIndex}][section_contents][${index}][section_content_items][${itemIndex}][image]`, item.image);
            //   } else {
            //     formData.append(`sub_sections[${subIndex}][section_contents][${index}][section_content_items][${itemIndex}][old_image]`, item.image);
            //   }
            //   formData.append(`sub_sections[${subIndex}][section_contents][${index}][section_content_items][${itemIndex}][title]`, item.title || "");
            //   formData.append(`sub_sections[${subIndex}][section_contents][${index}][section_content_items][${itemIndex}][description]`, item.description || "");
            // });
          });
        });
      }

      const res = await dispatch(
        updateSection({ sectionId, formData })
      ).unwrap();

      if (res.success) {
        setSnackbarMessage("Section updated successfully");
        setSnackbarVariant("success");
        setShowSnackbar(true);
        dispatch(
          getSections({
            payload: { slug: slug, organization_id: organizationId },
          })
        );
      } else {
        setSnackbarMessage(res.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    } catch (error) {
      console.error("Error updating section:", error);
      setSnackbarMessage("Failed to update section");
      setSnackbarVariant("danger");
      setShowSnackbar(true);
    } finally {
      setShowSnackbar(true);
      setEditingSectionId(null);
      setEditingSubSectionId(null);
    }
  };

  const openSubSectionModal = (subSectionId, slug) => {
    const section = sections?.data?.find((s) => s.slug === slug);
    const matchedSubSection = section?.sub_sections?.find(
      (ss) => ss.id === subSectionId?.id
    );

    if (matchedSubSection) {
      setSelectedSubSection(matchedSubSection);
      setShowModal(true);
    } else {
      console.warn(
        `Sub-section not found for ID: ${subSectionId?.id}, Slug: ${slug}`
      );
    }
  };

  const handleEditSubSection = (subSectionId) => {
    setEditingSubSectionId(subSectionId);
  };

  const handleCancel = () => {
    setEditingSectionId(null);
    setEditingSubSectionId(null);
  };

  // const generateDynamicTitle = (content, contentTypeCounts) => {
  //   let type = content.content_type;

  //   if (type === "html_text") {
  //     type = "Rich Text";
  //   }

  //   if (type === "string") {
  //     type = "Text";
  //   }

  //   if (!contentTypeCounts[type]) {
  //     contentTypeCounts[type] = { count: 1 };
  //   } else {
  //     contentTypeCounts[type].count += 1;
  //   }

  //   return contentTypeCounts[type].count > 1
  //     ? `${type.charAt(0).toUpperCase() + type.slice(1)} ${
  //         contentTypeCounts[type].count
  //       }`
  //     : `${type.charAt(0).toUpperCase() + type.slice(1)}`;
  // };

  const instagramColumns = [
    {
      label: "Image",
      key: "image",
      type: "image",
    },
    // {
    //   label: "Section Name",
    //   key: "name",
    //   type: "text",
    // },
    {
      label: "Link",
      key: "link",
      type: "text",
    },
  ];

  const bannerColumns = [
    {
      label: "Image",
      key: "image",
      type: "image",
    },
    // {
    //   label: "Section Name",
    //   key: "name",
    //   type: "text",
    // },
    {
      label: "Title",
      key: "title",
      type: "text",
    },
    {
      label: "Description",
      key: "description",
      type: "text",
    },
  ];

  const whyChooseUsColumns = [
    {
      label: "Image",
      key: "image",
      type: "image",
    },
    // {
    //   label: "Section Name",
    //   key: "name",
    //   type: "text",
    // },
    {
      label: "Title",
      key: "title",
      type: "text",
    },
    {
      label: "Description",
      key: "description",
      type: "text",
    },
  ];

  const latestLookBookColumns = [
    {
      label: "Section Name",
      key: "name",
      type: "text",
    },
    {
      label: "Title",
      key: "title",
      type: "text",
    },
    {
      label: "Image",
      key: "image",
      type: "image",
    },
    {
      label: "Link",
      key: "link",
      type: "text",
    },
  ];

  const aboutusHeroColumns = [
    // {
    //   label: "Section Name",
    //   key: "name",
    //   type: "text",
    // },
    {
      label: "Title",
      key: "title",
      type: "text",
    },
    {
      label: "Description",
      key: "description",
      type: "text",
    },
  ];

  const visionMissionColumns = [
    // {
    //   label: "Section Name",
    //   key: "name",
    //   type: "text",
    // },
    {
      label: "Title",
      key: "title",
      type: "text",
    },
    {
      label: "Description",
      key: "description",
      type: "text",
    },
  ];

  const transformInstagramData = (sub_sections) =>
    sub_sections.map((s) => ({
      id: s.id,
      name: s.title,
      link: s.section_contents.find((c) => c.content_type === "link")?.content,
      image: s.section_contents.find((c) => c.content_type === "image")
        ?.content,
    }));

  const transformBannerData = (subs = []) =>
    subs.map((s) => ({
      id: s?.id,
      name: s?.title || "",
      image:
        s?.section_contents?.find((c) => c.content_type === "image")?.content ||
        "",
      title:
        s?.section_contents?.find((c) => c.content_type === "header")
          ?.content || "",
      description:
        s?.section_contents?.find((c) => c.content_type === "text")?.content ||
        "",
    }));

  const transformOurLatestLookBook = (subs = []) =>
    subs.map((s) => ({
      id: s?.id,
      name: s?.title || "",
      title:
        s?.section_contents?.find((c) => c.content_type === "header")
          ?.content || "",
      image:
        s?.section_contents?.find((c) => c.content_type === "image")?.content ||
        "",
      link: s.section_contents.find((c) => c.content_type === "link")?.content,
    }));

  const transformAboutUsHeroData = (subs = []) =>
    subs.map((s) => ({
      id: s?.id,
      name: s?.title || "",
      title:
        s?.section_contents?.find((c) => c.content_type === "header")
          ?.content || "",
      description:
        s?.section_contents?.find((c) => c.content_type === "text")?.content ||
        "",
    }));

  const transformVisionMission = (subs = []) =>
    subs.map((s) => ({
      id: s?.id,
      name: s?.title || "",
      title:
        s?.section_contents?.find((c) => c.content_type === "header")
          ?.content || "",
      description:
        s?.section_contents?.find((c) => c.content_type === "text")?.content ||
        "",
    }));

  const handleDelete = (row) => {
    setDeleteSubSections(row?.id);
    setShowDeleteModal(true);
  };

  const handleDeleteNew = async (id) => {
    try {
      const res = await dispatch(deleteSubSection(id)).unwrap();
      if (res.success) {
        setSnackbarMessage("Section deleted successfully");
        setSnackbarVariant("success");
        setShowSnackbar(true);
        setShowDeleteModal(false);
        dispatch(
          getSections({
            payload: { slug: slug, organization_id: organizationId },
          })
        );
      } else {
        setSnackbarMessage(res.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting section:", error);
      setSnackbarMessage("Failed to delete section");
      setSnackbarVariant("danger");
      setShowSnackbar(true);
    }
  };

  const LABEL_MAP = {
  "follow-on-instagram": {
    header: "Header",
    link: "Instagram Link",
    image: "Image",
  },
  "banner-section": {
    header: "Header",
    text: "Description",
    image: "Banner Image",
  },
  "why-choose-us-section": {
    header: "Header",
    text: "Description",
    image: "Image",
  },
  "our-latest-lookbook": {
    header: "Title",
    link: "Link",
    image: "Image",
  },
  "about-us-hero-section": {
    header: "Header",
    text: "Description",
  },
  "our-vision-and-mission": {
    header: "Title",
    text: "Description",
  },
};


  if (!SectionData?.length)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <h2>No Data Available</h2>
      </div>
    );

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Container fluid className="px-0">
        {sections?.data?.map((section) => (
          <Card key={section.id} className="mb-4">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">{section.title}</h5>
              {(editingSectionId !== section.id && section.title !== "Banners") && (
                <CommonButton
                  title="Edit"
                  type="button"
                  className="btn-primary primary-shadow"
                  onClick={() => setEditingSectionId(section.id)}
                />
              )}
            </Card.Header>
            <Card.Body>
              {editingSectionId === section.id ? (
                <Formik
                  initialValues={{
                    section_contents: [...section.section_contents].sort(
                      (a, b) => a.order - b.order
                    ),
                  }}
                  onSubmit={(values) =>
                    handleSubmit(section.id, values.section_contents)
                  }
                >
                  {({ values, handleChange, setFieldValue, handleSubmit }) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          {values.section_contents.map((content, index) => (
                            <Col md={12} key={content.id} className="mb-3">
                              <CommonFormLabel
                                htmlFor={`content_${index}`}
                                title={content.label}
                              />
                              {content.content_type === "image" ? (
                                <>
                                  <FileInput
                                    name={`section_contents[${index}].content`}
                                    onChange={(file) =>
                                      setFieldValue(
                                        `section_contents[${index}].content`,
                                        file
                                      )
                                    }
                                    inputType="image"
                                  />
                                  {content.oldContent && (
                                    <img
                                      src={`${content.oldContent}`}
                                      alt={`Content ${index + 1}`}
                                      className="mt-2"
                                      style={{
                                        width: "150px",
                                        height: "auto",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                      }}
                                    />
                                  )}
                                </>
                              ) : content.content_type === "text" ? (
                                <Textarea
                                  id={`section_contents[${index}].content`}
                                  name={`section_contents[${index}].content`}
                                  placeholder={`Enter Content ${index + 1}`}
                                  onChange={handleChange}
                                  value={content.content}
                                  className="shadow-none"
                                  rows={4}
                                />
                              ) : content.content_type === "html_text" ? (
                                <Editor
                                  value={content.content}
                                  onChange={(content) =>
                                    setFieldValue(
                                      `section_contents[${index}].content`,
                                      content
                                    )
                                  }
                                  height="250px"
                                />
                              ) : (
                                <Input
                                  id={`section_contents[${index}].content`}
                                  name={`section_contents[${index}].content`}
                                  type="text"
                                  placeholder={`Enter Content ${index + 1}`}
                                  onChange={handleChange}
                                  value={content.content}
                                  className="mt-2 shadow-none"
                                />
                              )}
                            </Col>
                          ))}
                        </Row>
                        <div className="d-flex justify-content-end gap-3 mt-4">
                          <CommonButton
                            title="Save Changes"
                            type="submit"
                            className="btn-primary primary-shadow"
                          />
                          <CommonButton
                            title="Cancel"
                            type="button"
                            className="btn-muted"
                            onClick={handleCancel}
                          />
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              ) : (
                <>
                  <Row>
                    {section.section_contents.map((content, index) => (
                      <Col md={12} key={content.id} className="mb-3">
                        <CommonFormLabel
                          htmlFor={`content_${index}`}
                          title={content.label}
                        />
                        {content.content_type === "image" ? (
                          <div className="mt-2 p-2">
                            <img
                              src={`${content.content}`}
                              alt={`Content ${index + 1}`}
                              style={{
                                width: "150px",
                                height: "auto",
                                border: "1px solid #ddd",
                                borderRadius: "5px",
                              }}
                            />
                          </div>
                        ) : content.content_type === "html_text" ? (
                          <div className="mt-2 p-2">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: content.content,
                              }}
                            />
                          </div>
                        ) : (
                          <p className="mt-2 p-2">{content.content}</p>
                        )}
                      </Col>
                    ))}
                  </Row>
                  {/* Render sub-sections */}
                  {section.sub_sections && (
                    <>
                      {section.title !== "Banners" && <hr />}
                      <h4 className="mt-4 justify-content-center d-flex">
                        {section.title}
                      </h4>
                      {(section.slug === "follow-on-instagram" ||
                        section.slug === "banner-section" ||
                        section.slug === "why-choose-us-section" ||
                        section.slug === "our-latest-lookbook" ||
                        section.slug === "about-us-hero-section" ||
                        section.slug === "our-vision-and-mission") && (
                        <div className="d-flex justify-content-end mb-3">
                          <CommonButton
                            title="Add"
                            className="btn-primary primary-shadow"
                            onClick={() => {
                              setAddSectionType(section.slug);
                              setSelectedSubSection(section);
                              setShowAddModal(true);
                            }}
                          />
                        </div>
                      )}
                      {section.slug === "follow-on-instagram" && (
                        <div className="bg-white rounded-2 overflow-hidden common-shadow mb-4">
                          <CommonTable
                            columns={instagramColumns}
                            data={transformInstagramData(section.sub_sections)}
                            showActions={true}
                            actions={{
                              showEdit: true,
                              showDelete: true,
                              showView: false,
                              onEdit: (row) =>
                                openSubSectionModal(row, "follow-on-instagram"),
                              onDelete: handleDelete,
                            }}
                          />
                        </div>
                      )}

                      {section.slug === "banner-section" && (
                        <div className="bg-white rounded-2 overflow-hidden common-shadow mb-4">
                          <CommonTable
                            columns={bannerColumns}
                            data={transformBannerData(section.sub_sections)}
                            showActions={true}
                            actions={{
                              showEdit: true,
                              showDelete: true,
                              showView: false,
                              onEdit: (row) =>
                                openSubSectionModal(row, "banner-section"),
                              onDelete: handleDelete,
                            }}
                          />
                        </div>
                      )}

                      {section.slug === "why-choose-us-section" && (
                        <div className="bg-white rounded-2 overflow-hidden common-shadow mb-4">
                          <CommonTable
                            columns={whyChooseUsColumns}
                            data={transformBannerData(section.sub_sections)}
                            showActions={true}
                            actions={{
                              showEdit: true,
                              showDelete: true,
                              showView: false,
                              onEdit: (row) =>
                                openSubSectionModal(
                                  row,
                                  "why-choose-us-section"
                                ),
                              onDelete: handleDelete,
                            }}
                          />
                        </div>
                      )}

                      {section.slug === "our-latest-lookbook" && (
                        <div className="bg-white rounded-2 overflow-hidden common-shadow mb-4">
                          <CommonTable
                            columns={latestLookBookColumns}
                            data={transformOurLatestLookBook(
                              section.sub_sections
                            )}
                            showActions={true}
                            actions={{
                              showEdit: true,
                              showDelete: true,
                              showView: false,
                              onEdit: (row) =>
                                openSubSectionModal(row, "our-latest-lookbook"),
                              onDelete: handleDelete,
                            }}
                          />
                        </div>
                      )}

                      {section.slug === "about-us-hero-section" && (
                        <div className="bg-white rounded-2 overflow-hidden common-shadow mb-4">
                          <CommonTable
                            columns={aboutusHeroColumns}
                            data={transformAboutUsHeroData(
                              section.sub_sections
                            )}
                            showActions={true}
                            actions={{
                              showEdit: true,
                              showDelete: true,
                              showView: false,
                              onEdit: (row) =>
                                openSubSectionModal(
                                  row,
                                  "about-us-hero-section"
                                ),
                              onDelete: handleDelete,
                            }}
                          />
                        </div>
                      )}

                      {section.slug === "our-vision-and-mission" && (
                        <div className="bg-white rounded-2 overflow-hidden common-shadow mb-4">
                          <CommonTable
                            columns={visionMissionColumns}
                            data={transformVisionMission(section.sub_sections)}
                            showActions={true}
                            actions={{
                              showEdit: true,
                              showDelete: true,
                              showView: false,
                              onEdit: (row) =>
                                openSubSectionModal(
                                  row,
                                  "our-vision-and-mission"
                                ),
                              onDelete: handleDelete,
                            }}
                          />
                        </div>
                      )}

                      {section.slug !== "banner-section" &&
                        section.slug !== "follow-on-instagram" &&
                        section.slug !== "why-choose-us-section" &&
                        section.slug !== "our-latest-lookbook" &&
                        section.slug !== "about-us-hero-section" &&
                        section.slug !== "our-vision-and-mission" && (
                          <Row>
                            {section.sub_sections.map((subSection) => (
                              <Col key={subSection.id} md={12} className="mb-3">
                                <Card className="mb-3">
                                  <Card.Header className="d-flex justify-content-between align-items-center">
                                    <h5>{subSection.title}</h5>
                                    {editingSubSectionId !== subSection.id && (
                                      <CommonButton
                                        title="Edit"
                                        type="button"
                                        className="btn-primary primary-shadow"
                                        onClick={() =>
                                          handleEditSubSection(subSection.id)
                                        }
                                      />
                                    )}
                                  </Card.Header>
                                  <Card.Body>
                                    {editingSubSectionId === subSection.id ? (
                                      <Formik
                                        initialValues={{
                                          section_contents: [
                                            ...subSection.section_contents,
                                          ].sort((a, b) => a.order - b.order),
                                        }}
                                        onSubmit={(values) =>
                                          handleSubmit(
                                            subSection.id,
                                            values.section_contents,
                                            section.sub_sections
                                          )
                                        }
                                      >
                                        {({
                                          values,
                                          handleChange,
                                          setFieldValue,
                                          handleSubmit,
                                        }) => {
                                          return (
                                            <Form onSubmit={handleSubmit}>
                                              <Row>
                                                {values.section_contents.map(
                                                  (content, index) => (
                                                    <Col
                                                      md={12}
                                                      key={content.id}
                                                      className="mb-3"
                                                    >
                                                      <CommonFormLabel
                                                        htmlFor={`content_${index}`}
                                                        title={content.label}
                                                      />
                                                      {content.content_type ===
                                                      "image" ? (
                                                        <>
                                                          <FileInput
                                                            name={`section_contents[${index}].content`}
                                                            onChange={(file) =>
                                                              setFieldValue(
                                                                `section_contents[${index}].content`,
                                                                file
                                                              )
                                                            }
                                                            inputType="image"
                                                          />
                                                          {content.oldContent && (
                                                            <img
                                                              src={`${content.oldContent}`}
                                                              alt={`Content ${
                                                                index + 1
                                                              }`}
                                                              className="mt-2"
                                                              style={{
                                                                width: "150px",
                                                                height: "auto",
                                                                border:
                                                                  "1px solid #ddd",
                                                                borderRadius:
                                                                  "5px",
                                                              }}
                                                            />
                                                          )}
                                                        </>
                                                      ) : content.content_type ===
                                                        "text" ? (
                                                        <Textarea
                                                          id={`section_contents[${index}].content`}
                                                          name={`section_contents[${index}].content`}
                                                          placeholder={`Enter Content ${
                                                            index + 1
                                                          }`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          value={
                                                            content.content
                                                          }
                                                          className="shadow-none"
                                                          rows={4}
                                                        />
                                                      ) : content.content_type ===
                                                        "html_text" ? (
                                                        <Editor
                                                          value={
                                                            content.content
                                                          }
                                                          onChange={(content) =>
                                                            setFieldValue(
                                                              `section_contents[${index}].content`,
                                                              content
                                                            )
                                                          }
                                                          height="250px"
                                                        />
                                                      ) : (
                                                        <Input
                                                          id={`section_contents[${index}].content`}
                                                          name={`section_contents[${index}].content`}
                                                          type="text"
                                                          placeholder={`Enter Content ${
                                                            index + 1
                                                          }`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          value={
                                                            content.content
                                                          }
                                                          className="mt-2 shadow-none"
                                                        />
                                                      )}
                                                    </Col>
                                                  )
                                                )}
                                              </Row>
                                              <div className="d-flex justify-content-end gap-3 mt-4">
                                                <CommonButton
                                                  title="Save Changes"
                                                  type="submit"
                                                  className="btn-primary primary-shadow"
                                                />
                                                <CommonButton
                                                  title="Cancel"
                                                  type="button"
                                                  className="btn-muted"
                                                  onClick={handleCancel}
                                                />
                                              </div>
                                            </Form>
                                          );
                                        }}
                                      </Formik>
                                    ) : (
                                      <>
                                        {subSection.section_contents.map(
                                          (content, index) => (
                                            <Col
                                              md={12}
                                              key={content.id}
                                              className="mb-3"
                                            >
                                              <CommonFormLabel
                                                htmlFor={`content_${index}`}
                                                title={content.label}
                                              />
                                              {content.content_type ===
                                              "image" ? (
                                                <div className="mt-2 p-2">
                                                  <img
                                                    src={`${content.content}`}
                                                    alt={`Content ${index + 1}`}
                                                    style={{
                                                      width: "150px",
                                                      height: "auto",
                                                      border: "1px solid #ddd",
                                                      borderRadius: "5px",
                                                    }}
                                                  />
                                                </div>
                                              ) : content.content_type ===
                                                "html_text" ? (
                                                <div className="mt-2 p-2">
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: content.content,
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <p className="mt-2 p-2">
                                                  {content.content}
                                                </p>
                                              )}
                                            </Col>
                                          )
                                        )}
                                      </>
                                    )}
                                  </Card.Body>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        )}
                    </>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        ))}
        {showAddModal && selectedSubSection && (
          <Modal
            show={showAddModal}
            onHide={() => setShowAddModal(false)}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Add{" "}
                {addSectionType === "banner-section"
                  ? "Banner"
                  : addSectionType === "why-choose-us-section"
                  ? "Why Choose Us"
                  : addSectionType === "our-latest-lookbook"
                  ? "Our Latest Lookbook"
                  : addSectionType === "about-us-hero-section"
                  ? "About Us Hero"
                  : addSectionType === "our-vision-and-mission"
                  ? "Our Vision & Mission"
                  : "Instagram"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  name: "",
                  section_contents: [
                    ...(addSectionType === "follow-on-instagram" ||
                    addSectionType === "our-latest-lookbook"
                      ? [
                          {
                            content_type: "header",
                            label: "Headers",
                            order: 1,
                            content: "",
                          },
                          {
                            content_type: "link",
                            label: "Instagram Link",
                            order: 2,
                            content: "",
                          },
                          {
                            content_type: "image",
                            label: "Banner Image",
                            order: 2,
                            content: null,
                          },
                        ]
                      : addSectionType === "banner-section"
                      ? [
                          {
                            content_type: "header",
                            label: "Headers",
                            order: 1,
                            content: "",
                          },
                          {
                            content_type: "text",
                            label: "Description",
                            order: 2,
                            content: "",
                          },
                          {
                            content_type: "image",
                            label: "Banner Image",
                            order: 2,
                            content: null,
                          },
                        ]
                      : addSectionType === "why-choose-us-section"
                      ? [
                          {
                            content_type: "header",
                            label: "Headers",
                            order: 1,
                            content: "",
                          },
                          {
                            content_type: "text",
                            label: "Description",
                            order: 2,
                            content: "",
                          },
                          {
                            content_type: "image",
                            label: "Banner Image",
                            order: 2,
                            content: null,
                          },
                        ]
                      : [
                          {
                            content_type: "header",
                            label: "Header",
                            order: 1,
                            content: "",
                          },
                          {
                            content_type: "text",
                            label: "Description",
                            order: 2,
                            content: "",
                          },
                        ]),
                  ],
                }}
                onSubmit={async (values, { resetForm }) => {
                  try {
                    const formData = new FormData();

                    formData.append("organization_id", organizationId);
                    formData.append("section_id", selectedSubSection.id);
                    formData.append("section_name", values.name || "");

                    values.section_contents.forEach((item, index) => {
                      const path = `section_contents[${index}]`;
                      formData.append(
                        `${path}[content_type]`,
                        item.content_type
                      );
                      formData.append(`${path}[label]`, item.label || "");
                      formData.append(
                        `${path}[order]`,
                        item.order ?? index + 1
                      );
                      formData.append(`${path}[content]`, item.content); // works for both File or string
                    });

                    for (let pair of formData.entries()) {
                      console.log(`${pair[0]}:`, pair[1]);
                    }
                    setIsSubmitting(true);
                    const data = await dispatch(
                      addSubSection({ formData })
                    ).unwrap();

                    if (data.success) {
                      setSnackbarMessage("Sub-section added successfully");
                      setSnackbarVariant("success");
                      dispatch(
                        getSections({
                          payload: { slug, organization_id: organizationId },
                        })
                      );
                    } else {
                      setSnackbarMessage(data.message || "Failed to add");
                      setSnackbarVariant("danger");
                    }

                    setShowSnackbar(true);
                    setShowAddModal(false);
                    setSelectedSubSection(null);
                    resetForm();
                  } catch (err) {
                    console.error(err);
                    setSnackbarMessage("Something went wrong!");
                    setSnackbarVariant("danger");
                    setShowSnackbar(true);
                  } finally {
                    setIsSubmitting(false);
                  }
                }}
              >
                {({ values, handleChange, setFieldValue, handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      {/* <Col md={12}>
                        <CommonFormLabel title="Sub-Section Name" />
                        <Input
                          name="name"
                          value={values.name}
                          onChange={(e) =>
                            setFieldValue("name", e.target.value)
                          }
                          placeholder="Enter name"
                          />
                      </Col> */}

                      {/* <h4 className="text-center mt-2">Sub Section Contents</h4> */}
                      <Col md={12}>
                        {/* <div
                          className="p-3 mt-3"
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                          }}
                        > */}
                          {values.section_contents.map((content, idx) => (
                            <div key={idx} className="mb-3">
                              <CommonFormLabel
                                title={
                                  content.content_type.charAt(0).toUpperCase() +
                                  content.content_type.slice(1)
                                }
                              />
                              {content.content_type === "image" ? (
                                <FileInput
                                  inputType="image"
                                  onChange={(file) => {
                                    const updated = [
                                      ...values.section_contents,
                                    ];
                                    updated[idx].content = file;
                                    setFieldValue("section_contents", updated);
                                  }}
                                />
                              ) : content.content_type === "text" ? (
                                <Textarea
                                  name={`section_contents[${idx}].content`}
                                  value={content.content}
                                  label
                                  onChange={(e) =>
                                    setFieldValue(
                                      `section_contents[${idx}].content`,
                                      e.target.value
                                    )
                                  }
                                  rows={4}
                                />
                              ) : (
                                <Input
                                  name={`section_contents[${idx}].content`}
                                  value={content.content}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `section_contents[${idx}].content`,
                                      e.target.value
                                    )
                                  }
                                  placeholder={`Enter ${content.content_type.charAt(0).toUpperCase() + content.content_type.slice(1)}`}
                                />
                              )}
                            </div>
                          ))}
                        {/* </div> */}
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-end gap-3">
                      <CommonButton
                        title="Cancel"
                        type="button"
                        className="btn-muted"
                        onClick={() => {
                          setShowAddModal(false);
                          setSelectedSubSection(null);
                        }}
                      />
                      <CommonButton
                        title={
                          isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              />
                              Adding...
                            </>
                          ) : (
                            "Add"
                          )
                        }
                        type="submit"
                        className="btn-primary primary-shadow"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>
        )}

        {selectedSubSection && (
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit {selectedSubSection.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                section_contents: [...selectedSubSection.section_contents]
                    .sort((a, b) => {
                      const typeOrder = ["header", "text", "html_text", "link", "image"];
                      return (
                        typeOrder.indexOf(a.content_type) - typeOrder.indexOf(b.content_type)
                      );
                    })
                    .map((content) => ({
                      ...content,
                      label:
                        LABEL_MAP[selectedSubSection?.slug]?.[content.content_type] ??
                        content.label ??
                        content.content_type,
                    })),
                }}
                onSubmit={async (values) => {
                  setIsSubmitting(true);
                  try {
                    await handleSubmit(
                      selectedSubSection.id,
                      values.section_contents,
                      sections?.data?.find(
                        (s) => s.slug === "follow-on-instagram"
                      )?.sub_sections
                    );
                    setShowModal(false);
                    setSelectedSubSection(null);
                  } finally {
                    setIsSubmitting(false);
                  }
                }}
              >
                {({ values, handleChange, setFieldValue, handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      {values.section_contents.map((content, index) => (
                        <Col md={12} key={content.id} className="mb-3">
                          <CommonFormLabel
                            htmlFor={`content_${index}`}
                            title={content.label}
                          />
                          {
                           content.content_type === "text" ? (
                            <Textarea
                              id={`section_contents[${index}].content`}
                              name={`section_contents[${index}].content`}
                              placeholder={`Enter ${content.label}`}
                              onChange={handleChange}
                              value={content.content}
                              className="shadow-none"
                              rows={4}
                            />): content.content_type === "image" ? (
                            <>
                              <FileInput
                                name={`section_contents[${index}].content`}
                                onChange={(file) =>
                                  setFieldValue(
                                    `section_contents[${index}].content`,
                                    file
                                  )
                                }
                                inputType="image"
                              />
                              {content.oldContent && (
                                <img
                                  src={content.oldContent}
                                  alt={`Content ${index + 1}`}
                                  className="mt-2"
                                  style={{
                                    width: "150px",
                                    height: "auto",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                  }}
                                />
                              )}
                            </>
                          ): content.content_type === "html_text" ? (
                            <Editor
                              value={content.content}
                              onChange={(val) =>
                                setFieldValue(
                                  `section_contents[${index}].content`,
                                  val
                                )
                              }
                              height="250px"
                            />
                          ) : (
                            <Input
                              id={`section_contents[${index}].content`}
                              name={`section_contents[${index}].content`}
                              type="text"
                              placeholder={`Enter ${content.label}`}
                              onChange={handleChange}
                              value={content.content}
                              className="mt-2 shadow-none"
                            />
                          )}
                        </Col>
                      ))}
                    </Row>
                    <div className="d-flex justify-content-end gap-3 mt-4">
                      <CommonButton
                        title={
                          isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              />
                              Saving...
                            </>
                          ) : (
                            "Save Changes"
                          )
                        }
                        type="submit"
                        className="btn-primary primary-shadow"
                        disabled={isSubmitting}
                      />
                      <CommonButton
                        title="Cancel"
                        type="button"
                        className="btn-muted"
                        onClick={() => {
                          setShowModal(false);
                          setSelectedSubSection(null);
                        }}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>
        )}

        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this section?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => handleDeleteNew(deleteSubSections)}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default HomePage;
